export default {
  paymentId: '2A607B72CD544DCFB20E0CBD01A2A317',
  platform: 'vtex',
  confirmUrl: 'www.google.com.br',
  checkoutUrl: 'loja.vivo.com.br/checkout/#/payment',
  appKey: '5f90758fcc46679de50b82c8',
};
